import { logError } from "@/services/logging/logger";

export interface ApplePayTokenInput {
  paymentData: {
    data: string;
    signature: string;
    header: {
      publicKeyHash: string;
      ephemeralPublicKey: string;
      transactionId: string;
    };
    version: string;
  };
  paymentMethod: {
    displayName: string;
    network: string;
    type: string;
  };
  transactionIdentifier: string;
}

export interface ApplePayTokenOutput {
  data: string;
  signature: string;
  header: {
    publicKeyHash: string;
    ephemeralPublicKey: string;
    transactionId: string;
  };
  version: string;
  paymentMethod: {
    displayName: string;
    network: string;
    type: string;
  };
}

export const transformApplePayToken = (token: ApplePayTokenInput): string => {
  try {
    const transformedToken: ApplePayTokenOutput = {
      data: token.paymentData.data,
      signature: token.paymentData.signature,
      header: {
        publicKeyHash: token.paymentData.header.publicKeyHash,
        ephemeralPublicKey: token.paymentData.header.ephemeralPublicKey,
        transactionId: token.paymentData.header.transactionId,
      },
      version: token.paymentData.version,
      paymentMethod: {
        displayName: token.paymentMethod.displayName,
        network: token.paymentMethod.network,
        type: token.paymentMethod.type,
      },
    };

    return JSON.stringify(transformedToken);
  } catch (error) {
    logError(
      "apple-pay-token-transform",
      "Failed to transform Apple Pay token",
      error instanceof Error ? error : new Error(String(error)),
      { error },
    );
    throw new Error("Invalid Apple Pay token format");
  }
};
